import React from 'react'
import OrdersPageActions from 'orders/orders/ordersTable/header/pageActions'
import './searchAndDate.scss'

const OrderFilters: React.FC = () => (
    <div className="orders-page-actions-row">
        <OrdersPageActions />
    </div>
)

export default OrderFilters
